export const TABLE_FILTER_TYPE = Symbol('filter');
export const DEFAULT_FILTER_OPERATIONS = [
  'contains',
  'notContains',
  'startsWith',
  'endsWith',
  'equal',
  'notEqual',
];
